/**
 * 特典コードのご利用条件（掲示物）。
 *
 * 利用規約 第5条3項「本サイト上で掲載する本サービスの利用に関するルールは、本規約の一部を構成する」
 * により、掲示によって規約の一部として成立する。資金決済法の整理（無償発行のため対価性がなく非該当）を
 * 支えるのは有償譲渡・転売の禁止を明示することなので、ログイン不要な場所（/pricing）への掲示を必ず含める。
 *
 * このコンポーネントはリストだけを描く。見出しも折りたたみも持たず props も取らない——
 * 単一化が必要なのは文言であって囲みではなく、/profile（折りたたみ）と /pricing（掲示）で
 * 見せ方が違うため。文言の配列も export しない（公開すると「文言は1箇所」の不変条件が緩む）。
 */
const REDEMPTION_TERMS = [
  'コードはどなたでもご利用いただけます。ご自身で使うほか、他の方へ無償でお渡しいただけます。',
  '有償での譲渡・転売・換金はできません。現金や他の対価との交換もお受けできません。',
  '1つのコードは1回のみ、1アカウントでのみご利用いただけます。',
  'コードで増えるのは利用時間のみです。話者分離・手動修正・音声の保持期間などのプラン機能は、ご契約中のプランに従います。',
  '追加された時間に有効期限はありません。ご利用いただくまで保持されます。',
  '無償で配布するものであり、返金・再発行・紛失時の補償は行いません。',
  '無制限プランのアカウントではご利用いただけません（追加時間を消費しないため）。他の方へお渡しください。',
  '本サービスの提供を終了した場合、未使用のコードは失効します。',
] as const

export default function RedemptionTerms() {
  return (
    <ul className="list-disc list-inside space-y-2 text-sm text-text-sub leading-relaxed">
      {REDEMPTION_TERMS.map((term) => (
        <li key={term}>{term}</li>
      ))}
    </ul>
  )
}
